import { _ } from '@ngx-translate/core';

export const EVENT_TYPES = [
  { id: 0, name: _('common.constants.eventTypes.exhibition') },
  { id: 1, name: _('common.constants.eventTypes.conference') },
  { id: 2, name: _('common.constants.eventTypes.seminar') },
  { id: 3, name: _('common.constants.eventTypes.meeting') },
  { id: 4, name: _('common.constants.eventTypes.council') },
  { id: 5, name: _('common.constants.eventTypes.competition') },
  { id: 6, name: _('common.constants.eventTypes.leisure') },
  { id: 8, name: _('common.constants.eventTypes.tournament') },
  { id: 9, name: _('common.constants.eventTypes.webinar') },
  { id: 7, name: _('common.constants.eventTypes.other') },
];
